import {Grow} from "@mui/material";
import {Redirect, Route, Switch} from "react-router-dom"
import {allRoutes, loginRoutes} from "../../routes/router";
import MenuLogin from "./MenuLogin";
import { connect } from 'react-redux';

//Custom routing for logged users
const CustomRouter = (route, index) => <Route
    key={index}
    path={route.path}
    exact={route.exact}
    name={route.name}
    render={(props) => {
        return <MenuLogin>
            <route.component {...props} />
        </MenuLogin>
    }}/>
//Regular routing for public users
const AppRoutes = ({isLoggedIn}) => {
    // const token = localStorage.getItem('AUTHORIZATION_TOKEN_BLOG');
    return (
        <Switch>
            {
                allRoutes.map((route, index) =>
                    <Route
                        key={index}
                        path={route.path}
                        exact={route.exact}
                        name={route.name}
                        render={(props) => {
                            const {location} = props;
                            return (!route.public && !isLoggedIn)
                                ? <Redirect from={location.pathname} to="/login"/>
                                : <Grow style={{transformOrigin: '0 0 0'}}
                                        timeout={1000}>

                                    <route.component {...props} />

                                </Grow>
                        }}
                    />
                )
            }

            {
                loginRoutes.map(CustomRouter)
            }
        </Switch>
    )
}
const mapStateToProps = (state) => ({
    isLoggedIn: state.auth.isLoggedIn
})

export default connect(mapStateToProps)(AppRoutes);